import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CartItem, CartItemGroup } from './cart.model';

export interface CartState extends EntityState<CartItem, string>, ActiveState {
	activeGroup: CartItemGroup;
	activeVersion?: CartItem;
	editor: {
		/** This is used to understand what creative unit a user is interacting with. */
		activeId: string;
	}
}

const initialState: CartState = {
	active: null,
	activeVersion: null,
	activeGroup: null,
	editor: {
		activeId: null
	}
}

@Injectable({ providedIn: 'root' })
@StoreConfig({
	name: 'cart-item',
	resettable: true
})
export class CartStore extends EntityStore<CartState> {
	constructor() {
		super(initialState);
	}
}
